// The usable threads of a SAVED colorway, in stop order.
//
// One rule shared by the colorway editor (loadSavedColorway) and the
// artwork-page preview picker, so the two cannot disagree about what a saved
// colorway contains: a saved thread counts only when it names a stop and
// carries both a thread code and a color. Sorted by stop_index so any
// "first stop wins" decision does not depend on API response order.
export function usableSavedThreads(colorway) {
    return (colorway && Array.isArray(colorway.threads) ? colorway.threads : [])
        .filter((t) => t && t.code && t.hex)
        .slice()
        .sort((a, b) => (a.stop_index ?? 0) - (b.stop_index ?? 0))
}
